module.exports = __webpack_public_path__ + "assets/img/yl_logo.87f33cda.png";